import _ from 'lodash';
import { Button } from '@Primitive/Button';
import { getRandomSmallKey } from '@Utils/Micro';
import { ButtonSettings, ButtonThemeType } from './FormStruct';
import { SettingsElementItemsMgmtDialog, SettingsType } from '@Primitive/SettingsListType';
// ---------------------------------------------------------------------------------------------------
export function getButtonSettingsListInfo(label: string, dataPath: string, haveForceSend: boolean) {
    let res = {
        type: SettingsType.ItemsMgmtDialog,
        label: label,
        dataPath: dataPath,
        dialogStaticSize: { w: 0.6, h: 0.8 },
        itemsInfo: [{
            label: "Label",
            type: SettingsType.String,
            dataPath: "Label"
        },
        {
            label: "Theme",
            type: SettingsType.DropDown,
            dataPath: "Type",
            items: [
                { value: ButtonThemeType.Default, label: 'Default' },
                { value: ButtonThemeType.Primary, label: 'Primary' },
                { value: ButtonThemeType.Secondary, label: 'Secondary' },
                { value: ButtonThemeType.Custom, label: 'Custom' }
            ]
        },
        {
            label: "Color",
            type: SettingsType.ColorPicker,
            dataPath: "Color",
            tooltip: "It can be set only for buttons of type custom",
            isEnabled: (data, row) => row.Type == ButtonThemeType.Custom
        },
        {
            label: "Font Color",
            type: SettingsType.ColorPicker,
            dataPath: "FontColor",
            tooltip: "It can be set only for buttons of type custom",
            isEnabled: (data, row) => row.Type == ButtonThemeType.Custom
        },
        {
            label: "Flat",
            type: SettingsType.Boolean,
            tooltip: "Reduces the amount of layering on the screen, making it more readable.",
            dataPath: "Flat",
        },
        {
            type: SettingsType.Boolean,
            label: "Uppercase",
            tooltip: "Makes all of the letters uppercase",
            dataPath: "Uppercase"
        },
        {
            type: SettingsType.String,
            label: "Tooltip",
            dataPath: "Tooltip"
        }],
        createNewItem: () => {
            let key = getRandomSmallKey();
            let label = 'New button';
            return {
                Label: label,
                Flat: true,
                Type: ButtonThemeType.Default,
                Key: key,
                Color: 'rgb(0, 188, 212)',
                ForceSend: false
            };
        },
    } as SettingsElementItemsMgmtDialog<any>;

    if (haveForceSend)
        res.itemsInfo.push({
            label: "Force Send",
            type: SettingsType.Boolean,
            dataPath: "ForceSend",
            tooltip: "If it\'s enabled, it ignores the mandatory check for fields when sending data"
        });

    return res;
}
// ---------------------------------------------------------------------------------------------------
export function getButtonElement(btn: ButtonSettings,
    widthIn: number = 0,
    heightIn: number = 0,
    onClick: () => void = _.noop,
    borderRadius: number = 4) {
    let fontSize = 14;
    let sumChars: number = btn.Label.length;
    let width = widthIn;
    let height = heightIn;
    if (width > 0 && height > 0)
        fontSize = Math.floor(Math.min((width / sumChars) * 1.7, 0.9 * height, fontSize));

    if (width == 0)
        width = undefined;
    if (height == 0)
        height = undefined;

    let color = undefined;
    let bgColor = "white";
    switch (btn.Type) {
        case ButtonThemeType.Primary:
            bgColor = "rgb(0, 188, 212)";
            if (btn.Flat)
                color = 'rgb(0, 188, 212)';
            else
                color = 'white';
            break;
        case ButtonThemeType.Secondary:
            bgColor = "rgb(255, 64, 129)";
            if (btn.Flat)
                color = 'rgb(255, 64, 129)';
            else
                color = 'white';
            break;
        case ButtonThemeType.Custom:
            if (!_.isEmpty(btn.Color))
                bgColor = btn.Color;
            if (!_.isEmpty(btn.FontColor))
                color = btn.FontColor;
            break;
    }

    return <Button
        key={'button-' + btn.Key}
        width={width}
        height={height}
        borderRadius={borderRadius}
        shadowLevel={(btn.Flat) ? 0 : 1}
        label={btn.Label}
        labelAutoSize={true}
        labelMaxFontSize={fontSize}
        style={{
            width: width,
            height: height,
            overflow: 'hidden',
            backgroundColor: (btn.Flat) ? undefined : bgColor,
            color: color,
            textTransform: btn.Uppercase ? 'uppercase' : 'initial'
        }}
        tooltip={btn.Tooltip}
        onClick={onClick}
        tabIndex={-1}
    />;
}
// ================================================================================================